import { render, staticRenderFns } from "./StatsPanel.vue?vue&type=template&id=e0dddb2e&scoped=true&"
import script from "./StatsPanel.vue?vue&type=script&lang=js&"
export * from "./StatsPanel.vue?vue&type=script&lang=js&"
import style0 from "./StatsPanel.vue?vue&type=style&index=0&id=e0dddb2e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0dddb2e",
  null
  
)

export default component.exports